export default "__VITE_ASSET__B2kH_XR6__"